import {ValidateFunc} from '@/project'

const isPersonRNum: ValidateFunc = (number) => {
  const REG_EXP = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))[1-8][0-9]{6}$/
  if(REG_EXP.test(number)) {
    let sum = 0
    const parse = number

    if(parse[6] < 5) {
      // 주민등록번호 뒷자리의 첫번째 수가 1~4인 경우 (내국인)
      for(let i = 2; i <= 9; i += 1) {
        sum += Number(parse[i - 2] * i)
      }

      for(let i = 2; i <= 5; i += 1) {
        sum += Number(parse[i + 6] * i)
      }

      return (11 - sum % 11) % 10 === Number(parse[12])
    }

    for(let i = 2; i <= 9; i += 1) {
      sum += Number(parse[i - 2] * i)
    }

    for(let i = 2; i <= 5; i += 1) {
      sum += Number(parse[i + 6] * i)
    }

    if((13 - sum % 11) % 10 === Number(parse[12])) {
      return true
    }
  }
  return false
}

export default isPersonRNum
